<template>
  <b-modal ref="my-modal" hide-footer title="Using Component Methods">
    <div class="d-block text-center">
      <h3>Hello From My Modal!</h3>
    </div>
    <b-button class="mt-3" variant="outline-danger" block @click="close"
      >Close Me</b-button
    >
    <!-- <b-button class="mt-2" variant="outline-warning" block @click="toggleModal"
      >Toggle Me</b-button
    > -->
  </b-modal>
</template>

<script>
export default {
  name: "QuantityModal",
  data() {
    return {
      reprint: {
        barcode: "",
        notes: "",
      },
    };
  },
  props: {
    data: Array,
  },
  methods: {
    close: function () {
      this.$emit("close");
    },
  },
};
</script>
<style>

</style>